import "./index.css";
import React from "react";
import ListViewIcon from "../../../../assets/media/products/list-view.png";
import MapViewIcon from "../../../../assets/media/products/map-view.png";

export default function ViewButton({
  label,
  mobileLabel,
  isMapOpen,
  white,
  hex,
  onClick,
  title,
  isDisabled = false,
}) {
  const brandTextColor = white ? "white" : "black";
  const isMapButton = label === "Map view";
  return (
    <button
      className={`shop__map-btn btn btn-white ${
        isMapOpen ? "" : "shop__map-btn--selected"
      } ${isDisabled ? "shop__map-btn--disabled" : ""}`}
      style={{
        "--bg-color": isMapOpen ? "#6c757d" : hex,
        "--text-color": isMapOpen ? "white" : brandTextColor,
      }}
      type="button"
      onClick={onClick}
      disabled={isDisabled}
      title={title}
    >
      <img
        src={isMapButton ? MapViewIcon : ListViewIcon}
        alt="list icon"
        className={`shop__list-icon ${
          isMapOpen || white ? "" : "shop__list-icon--black"
        }`}
      />
      <span className="shop__btn-label">{label}</span>
      <span className="shop__btn-label--mobile">{mobileLabel}</span>
    </button>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Products/components/ViewButton/index.js